import sortBy from "lodash/sortBy";

import {
  Supervisor as SupervisorType,
  FreeFortuneItem,
  FreeFortuneContent,
} from "shared/types";
import dynamic from "next/dynamic";

const Heading = dynamic(async () => (await import("../atoms/Heading")).Heading);

const Text = dynamic(async () => (await import("../v2/Text")).Text);

const Tarot1 = dynamic(async () => (await import("../v2/Tarot1")).Tarot1);

const Supervisor = dynamic(
  async () => (await import("../v2/Supervisor")).Supervisor
);

const BackToParent = dynamic(
  async () => (await import("../v2/BackToParent")).BackToParent
);

const ResultLinks = dynamic(
  async () => (await import("./ResultLinks")).ResultLinks
);

const FortuneIndex = dynamic(
  async () => (await import("./FortuneIndex")).FortuneIndex
);

const LinkButton = dynamic(
  async () => (await import("../atoms/LinkButton")).LinkButton
);

const ConversionLink = dynamic(
  async () => (await import("../v2/ConversionLink")).ConversionLink
);

const CheckedListItem = dynamic(
  async () => (await import("./CheckedListItem")).CheckedListItem
);

const BluredTextBackground = dynamic(
  async () => (await import("../v2/BluredTextBackground")).BluredTextBackground
);

interface Props {
  items: FreeFortuneItem[];
  fortuneTeller?: SupervisorType;
  freeFortuneContent?: FreeFortuneContent;
  className?: string;
}

const renderItem = (
  item: FreeFortuneItem,
  fortuneTeller?: SupervisorType,
  freeFortuneContent?: FreeFortuneContent
) => {
  switch (item.type) {
    case "heading_1":
      return <Heading tw="px-4 mb-5">{item.body}</Heading>;
    case "text_1":
      return <Text tw="px-4 mb-5">{item.body}</Text>;
    case "tarot_1":
      return (
        freeFortuneContent && (
          <Tarot1 tw="mt-[58px] mb-5" contentId={freeFortuneContent.id} />
        )
      );
    case "supervisor_1":
      return (
        fortuneTeller && (
          <Supervisor
            fortuneTeller={fortuneTeller}
            item={item}
            tw="px-4 mt-[77px] mb-5"
          />
        )
      );
    case "back_to_parent_1":
      return (
        <div tw="mx-4">
          <BackToParent tw="mt-3" item={item} />
        </div>
      );
    case "result_links_1":
      return (
        freeFortuneContent && (
          <div tw="mx-4">
            <ResultLinks tw="mb-5" freeFortuneContent={freeFortuneContent} />
          </div>
        )
      );
    case "conversion_link_1":
      return (
        <div tw="mx-4 mt-5">
          <ConversionLink item={item} />
        </div>
      );
    case "link_button_1":
      return <LinkButton item={item} />;
    case "fortune_index_1":
      return (
        <FortuneIndex fortuneIndexes={item.childs} tw="mx-6 mt-14 mb-10" />
      );
    case "background_1":
      return <BluredTextBackground item={item} tw="mt-8" />;
    case "list_item_1":
      return <CheckedListItem item={item} tw="mt-5 px-4" />;
    default:
      return <div />;
  }
};

export const ContentItem = ({
  items,
  fortuneTeller,
  freeFortuneContent,
  className,
}: Props) => {
  if (!items) return null;

  const sortedItems = sortBy(items, "order");

  return (
    <div className={className}>
      {sortedItems.map((item) => (
        <div key={item.id}>
          {renderItem(item, fortuneTeller, freeFortuneContent)}
        </div>
      ))}
    </div>
  );
};
